import { useFormik } from 'formik';
import { FraudModeParamsDataProps } from './props';
import { useEffect } from 'react';

export const useFraudModeData = ({ data }: FraudModeParamsDataProps) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            active: false,
            extra: '',
            valueSmart: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active || false);
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('valueSmart', data?.valueSmart || '');
    }, [data]);

    return {
        formik,
    };
};
